import Search from "./modules/Search";
import $ from 'jquery';

// Wrap in $(document).ready
$(document).ready(function() {
    const search = new Search();
});